import { getTHERMSImageSmallUrl } from "../../../../Files/utils/get-therms-image-small-url.js";
import "react";
import { Avatar, Button } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/AuthWrapper2/components/Login/views/UserAuthCard.tsx
function UserAuthCard({ onClick, user }) {
	return /* @__PURE__ */ jsx(Button, {
		className: "bg-surface hover:bg-neutral-faded group",
		subtle: true,
		onClick,
		children: /* @__PURE__ */ jsxs("div", {
			className: "gap-y-lg flex h-full flex-col items-center",
			children: [
				/* @__PURE__ */ jsx(Avatar, {
					circular: true,
					size: "xl",
					url: getTHERMSImageSmallUrl(user.user.avatarUrl)
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "grow text-center",
					children: [/* @__PURE__ */ jsx("span", {
						className: "text-color group-hover:text-color-strong group-active:text-color-subtle text-lg break-all transition",
						children: user.user.displayName
					}), /* @__PURE__ */ jsx("div", {
						className: "text-color-subtle group-hover:text-color group-active:text-color-subtle font-normal transition",
						children: user.user.title
					})]
				}),
				/* @__PURE__ */ jsx("div", {
					className: "tracking-wide",
					children: user.organization.name
				})
			]
		})
	});
}
export { UserAuthCard };

//# sourceMappingURL=UserAuthCard.js.map